import { graphql } from 'graphql-schema';
import { DISCOVER_RENTAL_SPORT_CARD_FRAGMENT } from '../../../../Discover';

const GET_OPEN_RENTALS = graphql(
  `
    query getOpenRentals($venueId: uuid!) {
      rentals(
        where: {
          venue: { _eq: $venueId }
          is_discoverable: { _eq: true }
          timeslots: { reservation: { _is_null: true }, start_time: { _gt: "now()" } }
        }
        order_by: { sportBySport: { name: asc } }
      ) {
        _id
        sportBySport {
          _id
          name
          value
        }
        ...DiscoverRentalSportCard
      }
    }
  `,
  [DISCOVER_RENTAL_SPORT_CARD_FRAGMENT]
);

export default GET_OPEN_RENTALS;
